import React, { useState, useEffect } from "react";
import _ from 'lodash';

const PropertyTypeCheckBox = (props) => {

    const handleCheck = (e) => {
        //console.log("checked", e.target.checked)

        if (e.target.checked) {
            props.setPropertyType([...props?.property_type_val, e.target.value])
        } else {
            // var mustincl_arr = props.mustInclude_Arr;
            // var index = mustincl_arr.indexOf(e.target.value); // Let's say it's Bob.
            // if (index !== -1) {
            //     mustincl_arr.splice(index, 1);
            //     props.setMustIncludeArr(mustincl_arr)
            // }

            var removeItem = props?.property_type_val.filter(item => item !== e.target.value)
            props.setPropertyType(removeItem)
        }
    }


    var prop_type_arr = props.options;

    return (
        <div className="container-box">
            {prop_type_arr.length > 0 && prop_type_arr.map((item, index) => {

                var checked_val = props?.property_type_val?.filter(value => value === item.value)
                //var checked_val = ""
                return (
                    <label class="container-wrap">{item.label}
                        <input type="checkbox" value={item.value} onChange={handleCheck} checked={checked_val.length > 0 ? true : false}></input>
                        <span class="checkmark"></span>
                    </label>
                )
            })}

        </div>
    );
};
export default PropertyTypeCheckBox;